import type { BotProtectionProviderAdapter } from './types'
import { renderTurnstileBotProtectionWidget } from './turnstileLifecycle'

export const turnstileBotProtectionAdapter: BotProtectionProviderAdapter = {
  providerId: 'turnstile',
  renderWidget: renderTurnstileBotProtectionWidget,
}
